import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class ServicehotelService {

  constructor(private http: HttpClient, private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/serviceshotel/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/serviceshotel/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('config/serviceshotel/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('config/serviceshotel/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('config/serviceshotel/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('config/serviceshotel/delete', val_id);
  }
}
